import { cn } from '@/lib/utils'
import { displayName } from './account'

/**
 * The tenant's business name in the app frame. The product name is never a
 * stand-in for it: while the name is unknown (first load, or
 * /api/workspaces/me failed with nothing cached) a neutral placeholder bar
 * shows instead of "BizForge OS".
 */
export function BusinessName({ name, className }: { name: string | null | undefined; className?: string }) {
  const label = displayName(name, '')
  if (!label) {
    return (
      <span className={cn('block', className)} data-testid="business-name-pending">
        <span aria-hidden className="block h-3 w-24 max-w-full rounded-full bg-white/[0.08]" />
        <span className="sr-only">Business name loading</span>
      </span>
    )
  }
  return <span className={className} data-testid="business-name">{label}</span>
}
